import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { BonusSettlementsCustomerDetailApi } from '../api/bonus-settlements-customer-detail-api';

const api = new BonusSettlementsCustomerDetailApi(API_BASE_URL);

export const bonusSettlementCustomerDetailsSidebarReset = createAction('bonusSettlement/details-reset');
export const bonusSettlementCustomerDetailsReset = createAction('bonusSettlement/suppliers-reset');

interface GetBonusSettlementsCustomerDetailParams {
    bonusSettlementId: number;
    customerId: number;
}

export const getBonusSettlementCustomerDetailSidebar = createAsyncThunk(
    'bonusSettlement/getBonusSettlementCustomerDetailSidebar',
    async (params: GetBonusSettlementsCustomerDetailParams, thunkAPI) => {
        const response = await api.getBonusSettlementCustomerDetailSidebar(params.bonusSettlementId, params.customerId);

        if (response.success) {
            return response.result;
        }

        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

        return null;
    }
);

export const getBonusSettlementCustomerDetails = createAsyncThunk(
    'bonusSettlement/getBonusSettlementCustomerDetails',
    async (
        { id, customerId, searchParams }: { id: number; customerId: number; searchParams?: URLSearchParams },
        thunkAPI
    ) => {
        const response = await api.getBonusSettlementCustomerDetails(id, customerId, searchParams);

        if (response.success) {
            return response.result;
        }
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

        return null;
    }
);

export const resetBonusSettlementsCustomerDetailState = createAction<void>(
    'bonus-settlements/resetBonusSettlementsSupplierOverviewState'
);
